import * as tslib_1 from "tslib";
import { createReducer, on, } from '@ngrx/store';
import * as actions from './actions';
export var initialState = {
    courses: [],
    courseDetails: {},
    coursesAreStubbed: true,
    currentCourse: null,
    currentLesson: null,
    currentContentItem: null,
    currentContentType: null,
    coursesProgressTimestamp: 0,
    videoProgress: {},
    videoPostTimes: {},
};
var ɵ0 = function (state, action) { return (tslib_1.__assign({}, state, { coursesAreStubbed: false, courses: action.courses, courseDetails: tslib_1.__assign({}, state.courseDetails, action.courses.reduce(function (agg, cur) {
        agg[cur.url_slug] = cur;
        return agg;
    }, {})) })); }, ɵ1 = function (state, action) {
    if (!state.courses.length || state.coursesAreStubbed)
        return tslib_1.__assign({}, state, { coursesAreStubbed: true, courses: action.courses });
    return state;
}, ɵ2 = function (state, action) {
    var _a;
    //return the state with the new course info
    return tslib_1.__assign({}, state, { courseDetails: tslib_1.__assign({}, state.courseDetails, (_a = {}, _a[action.course.url_slug] = action.course, _a)) });
}, ɵ3 = function (state, action) { return (tslib_1.__assign({}, state, { currentCourse: action.currentCourse })); }, ɵ4 = function (state, action) { return (tslib_1.__assign({}, state, { currentLesson: action.currentLesson })); }, ɵ5 = function (state, action) { return (tslib_1.__assign({}, state, { currentContentItem: action.item, currentContentType: action.itemType })); }, ɵ6 = function (state, action) {
    var _a;
    return (tslib_1.__assign({}, state, { videoPostTimes: tslib_1.__assign({}, state.videoPostTimes, (_a = {}, _a[action.videoId] = action.postTime, _a)) }));
}, ɵ7 = function (state, action) {
    var _a;
    return (tslib_1.__assign({}, state, { videoProgress: tslib_1.__assign({}, state.videoProgress, (_a = {}, _a[action.videoId] = { position: action.progress, modifiedDate: new Date() }, _a)) }));
}, ɵ8 = function (state, action) { return (tslib_1.__assign({}, state, { videoProgress: action.list.reduce(function (agg, cur) {
        var _a;
        return (tslib_1.__assign({}, agg, (_a = {}, _a[cur.videoId] = { position: cur.progress, modifiedDate: cur.modifiedDate }, _a)));
    }, {}) })); };
var userReducer = createReducer(initialState, 
// on(courseActions.courseListRequested, state => ({...state, courseList: []})),
on(actions.courseListReceived, ɵ0), on(actions.courseStubListReceived, ɵ1), on(actions.setCourseDetails, ɵ2), on(actions.setCurrentCourse, ɵ3), on(actions.setCurrentLesson, ɵ4), on(actions.setCurrentLessonItem, ɵ5), on(actions.setVideoLastPostTime, ɵ6), on(actions.setVideoProgress, ɵ7), on(actions.setVideoProgressList, ɵ8));
export function reducer(state, action) {
    return userReducer(state, action);
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8 };
